module.exports = __webpack_public_path__ + "img/10029.01c048ac.jpg";